"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.17.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderProgressionApi = void 0;
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var OrderProgressionApi = /** @class */ (function (_super) {
    __extends(OrderProgressionApi, _super);
    function OrderProgressionApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
     * Archives a given policy
     */
    OrderProgressionApi.prototype.archivePolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling archivePolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}/archive".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This archives the policy, ie. changes from is_draft=False, is_active=True to is_draft=False, is_active=False
     * Archives a given policy
     */
    OrderProgressionApi.prototype.archivePolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.archivePolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Requisition billing documents review
     */
    OrderProgressionApi.prototype.billingDocumentDetailsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling billingDocumentDetailsFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/billing-review/details/{rqid}".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDocumentReviewDetailsResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Requisition billing documents review
     */
    OrderProgressionApi.prototype.billingDocumentDetailsFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.billingDocumentDetailsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lists billing review queue
     */
    OrderProgressionApi.prototype.billingDocumentsReviewListFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.payers) {
                            queryParameters['payers'] = requestParameters.payers;
                        }
                        if (requestParameters.specimenReceived !== undefined) {
                            queryParameters['specimenReceived'] = requestParameters.specimenReceived;
                        }
                        if (requestParameters.paRequirement) {
                            queryParameters['paRequirement'] = requestParameters.paRequirement;
                        }
                        if (requestParameters.billingGroup) {
                            queryParameters['billingGroup'] = requestParameters.billingGroup;
                        }
                        if (requestParameters.primaryCommercialArea) {
                            queryParameters['primaryCommercialArea'] = requestParameters.primaryCommercialArea;
                        }
                        if (requestParameters.billingDocReviewStatus) {
                            queryParameters['billingDocReviewStatus'] = requestParameters.billingDocReviewStatus;
                        }
                        if (requestParameters.ordering !== undefined) {
                            queryParameters['ordering'] = requestParameters.ordering;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/billing-review/list",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDocumentReviewListResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Lists billing review queue
     */
    OrderProgressionApi.prototype.billingDocumentsReviewListFromOrderProgressionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.billingDocumentsReviewListFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This will create a new draft of the policy
     * Creates a new version in draft mode from a given policy
     */
    OrderProgressionApi.prototype.cloneDraftPolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling cloneDraftPolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}/new-version-draft".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This will create a new draft of the policy
     * Creates a new version in draft mode from a given policy
     */
    OrderProgressionApi.prototype.cloneDraftPolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cloneDraftPolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Confirms the indication and its attributes
     */
    OrderProgressionApi.prototype.confirmIndicationFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationId === null || requestParameters.indicationId === undefined) {
                            throw new runtime.RequiredError('indicationId', 'Required parameter requestParameters.indicationId was null or undefined when calling confirmIndicationFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indications/{indicationId}/confirm-derived-models".replace("{".concat("indicationId", "}"), encodeURIComponent(String(requestParameters.indicationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Confirms the indication and its attributes
     */
    OrderProgressionApi.prototype.confirmIndicationFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.confirmIndicationFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Confirms the relative and child models
     */
    OrderProgressionApi.prototype.confirmRelativeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.relativeId === null || requestParameters.relativeId === undefined) {
                            throw new runtime.RequiredError('relativeId', 'Required parameter requestParameters.relativeId was null or undefined when calling confirmRelativeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/relatives/{relativeId}/confirm-derived-models".replace("{".concat("relativeId", "}"), encodeURIComponent(String(requestParameters.relativeId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * Confirms the relative and child models
     */
    OrderProgressionApi.prototype.confirmRelativeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.confirmRelativeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * Create a new indication attribute configuration
     */
    OrderProgressionApi.prototype.createAttributeConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.opsNewAttributeConfigRequestObjectDto === null || requestParameters.opsNewAttributeConfigRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsNewAttributeConfigRequestObjectDto', 'Required parameter requestParameters.opsNewAttributeConfigRequestObjectDto was null or undefined when calling createAttributeConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/attribute-configs",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsNewAttributeConfigRequestObjectDtoToJSON)(requestParameters.opsNewAttributeConfigRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationAttributeConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * Create a new indication attribute configuration
     */
    OrderProgressionApi.prototype.createAttributeConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createAttributeConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new indication for medical necessity review
     * Create a new indication configuration
     */
    OrderProgressionApi.prototype.createIndicationConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.opsNewIndicationConfigRequestObjectDto === null || requestParameters.opsNewIndicationConfigRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsNewIndicationConfigRequestObjectDto', 'Required parameter requestParameters.opsNewIndicationConfigRequestObjectDto was null or undefined when calling createIndicationConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsNewIndicationConfigRequestObjectDtoToJSON)(requestParameters.opsNewIndicationConfigRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new indication for medical necessity review
     * Create a new indication configuration
     */
    OrderProgressionApi.prototype.createIndicationConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createIndicationConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new policy record for meeting medical necessity
     * Creates a new policy
     */
    OrderProgressionApi.prototype.createPolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.opsNewPolicyRequestObjectDto === null || requestParameters.opsNewPolicyRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsNewPolicyRequestObjectDto', 'Required parameter requestParameters.opsNewPolicyRequestObjectDto was null or undefined when calling createPolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies",
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsNewPolicyRequestObjectDtoToJSON)(requestParameters.opsNewPolicyRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new policy record for meeting medical necessity
     * Creates a new policy
     */
    OrderProgressionApi.prototype.createPolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This will create a new rule for the given policy
     * Creates a new rule for a policy
     */
    OrderProgressionApi.prototype.createPolicyRuleFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling createPolicyRuleFromOrderProgressionController.');
                        }
                        if (requestParameters.opsNewRuleRequestObjectDto === null || requestParameters.opsNewRuleRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsNewRuleRequestObjectDto', 'Required parameter requestParameters.opsNewRuleRequestObjectDto was null or undefined when calling createPolicyRuleFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}/rules".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsNewRuleRequestObjectDtoToJSON)(requestParameters.opsNewRuleRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This will create a new rule for the given policy
     * Creates a new rule for a policy
     */
    OrderProgressionApi.prototype.createPolicyRuleFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.createPolicyRuleFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an indication attribute configuration
     */
    OrderProgressionApi.prototype.deleteAttributeConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.attributeConfigId === null || requestParameters.attributeConfigId === undefined) {
                            throw new runtime.RequiredError('attributeConfigId', 'Required parameter requestParameters.attributeConfigId was null or undefined when calling deleteAttributeConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/attribute-configs/{attributeConfigId}".replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(requestParameters.attributeConfigId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete an indication attribute configuration
     */
    OrderProgressionApi.prototype.deleteAttributeConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteAttributeConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an indication attribute
     */
    OrderProgressionApi.prototype.deleteIndicationAttributeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.attributeId === null || requestParameters.attributeId === undefined) {
                            throw new runtime.RequiredError('attributeId', 'Required parameter requestParameters.attributeId was null or undefined when calling deleteIndicationAttributeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-attributes/{attributeId}".replace("{".concat("attributeId", "}"), encodeURIComponent(String(requestParameters.attributeId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete an indication attribute
     */
    OrderProgressionApi.prototype.deleteIndicationAttributeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteIndicationAttributeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an indication configuration
     */
    OrderProgressionApi.prototype.deleteIndicationConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationConfigId === null || requestParameters.indicationConfigId === undefined) {
                            throw new runtime.RequiredError('indicationConfigId', 'Required parameter requestParameters.indicationConfigId was null or undefined when calling deleteIndicationConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs/{indicationConfigId}".replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(requestParameters.indicationConfigId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete an indication configuration
     */
    OrderProgressionApi.prototype.deleteIndicationConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteIndicationConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete an indication
     */
    OrderProgressionApi.prototype.deleteIndicationFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationId === null || requestParameters.indicationId === undefined) {
                            throw new runtime.RequiredError('indicationId', 'Required parameter requestParameters.indicationId was null or undefined when calling deleteIndicationFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indications/{indicationId}".replace("{".concat("indicationId", "}"), encodeURIComponent(String(requestParameters.indicationId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete an indication
     */
    OrderProgressionApi.prototype.deleteIndicationFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteIndicationFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This deletes the policy is_draft=True, is_active=False
     * DELETES a given policy
     */
    OrderProgressionApi.prototype.deletePolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling deletePolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This deletes the policy is_draft=True, is_active=False
     * DELETES a given policy
     */
    OrderProgressionApi.prototype.deletePolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deletePolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a relative by id
     */
    OrderProgressionApi.prototype.deleteRelativeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.relativeId === null || requestParameters.relativeId === undefined) {
                            throw new runtime.RequiredError('relativeId', 'Required parameter requestParameters.relativeId was null or undefined when calling deleteRelativeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/relatives/{relativeId}".replace("{".concat("relativeId", "}"), encodeURIComponent(String(requestParameters.relativeId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete a relative by id
     */
    OrderProgressionApi.prototype.deleteRelativeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRelativeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete Requisition by ReqRepo Requisition Id
     */
    OrderProgressionApi.prototype.deleteRqFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling deleteRqFromOrderProgressionController.');
                        }
                        if (requestParameters.force === null || requestParameters.force === undefined) {
                            throw new runtime.RequiredError('force', 'Required parameter requestParameters.force was null or undefined when calling deleteRqFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.force !== undefined) {
                            queryParameters['force'] = requestParameters.force;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{rqid}".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsRequisitionDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete Requisition by ReqRepo Requisition Id
     */
    OrderProgressionApi.prototype.deleteRqFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRqFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Delete a medical necessity rule
     */
    OrderProgressionApi.prototype.deleteRuleFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
                            throw new runtime.RequiredError('ruleId', 'Required parameter requestParameters.ruleId was null or undefined when calling deleteRuleFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/medical-necessity-rules/{ruleId}".replace("{".concat("ruleId", "}"), encodeURIComponent(String(requestParameters.ruleId))),
                            method: 'DELETE',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsDeleteResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Delete a medical necessity rule
     */
    OrderProgressionApi.prototype.deleteRuleFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.deleteRuleFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Lists document tags
     */
    OrderProgressionApi.prototype.documentTagsFromOrderProgressionControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/billing-review/document-tags",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.OpsDocumentTagResponseDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Lists document tags
     */
    OrderProgressionApi.prototype.documentTagsFromOrderProgressionController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.documentTagsFromOrderProgressionControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a indication attribute configuration by id
     */
    OrderProgressionApi.prototype.getAttributeConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.attributeConfigId === null || requestParameters.attributeConfigId === undefined) {
                            throw new runtime.RequiredError('attributeConfigId', 'Required parameter requestParameters.attributeConfigId was null or undefined when calling getAttributeConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/attribute-configs/{attributeConfigId}".replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(requestParameters.attributeConfigId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationAttributeConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a indication attribute configuration by id
     */
    OrderProgressionApi.prototype.getAttributeConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAttributeConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Available indications attribute definitions
     * Returns a list indication attribute configurations for the indication
     */
    OrderProgressionApi.prototype.getAttributeConfigsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.filters !== undefined) {
                            queryParameters['filters'] = requestParameters.filters;
                        }
                        if (requestParameters.otherFilters !== undefined) {
                            queryParameters['otherFilters'] = requestParameters.otherFilters;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/attribute-configs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSearchAttributeConfigResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Available indications attribute definitions
     * Returns a list indication attribute configurations for the indication
     */
    OrderProgressionApi.prototype.getAttributeConfigsFromOrderProgressionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getAttributeConfigsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get list of available cpts for billing
     */
    OrderProgressionApi.prototype.getCptsFromOrderProgressionControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/cpts",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * Get list of available cpts for billing
     */
    OrderProgressionApi.prototype.getCptsFromOrderProgressionController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getCptsFromOrderProgressionControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a indication configuration by id
     */
    OrderProgressionApi.prototype.getIndicationConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationConfigId === null || requestParameters.indicationConfigId === undefined) {
                            throw new runtime.RequiredError('indicationConfigId', 'Required parameter requestParameters.indicationConfigId was null or undefined when calling getIndicationConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs/{indicationConfigId}".replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(requestParameters.indicationConfigId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a indication configuration by id
     */
    OrderProgressionApi.prototype.getIndicationConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIndicationConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list indication names with configurations
     */
    OrderProgressionApi.prototype.getIndicationConfigsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.filters !== undefined) {
                            queryParameters['filters'] = requestParameters.filters;
                        }
                        if (requestParameters.otherFilters !== undefined) {
                            queryParameters['otherFilters'] = requestParameters.otherFilters;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSearchIndicationConfigResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a list indication names with configurations
     */
    OrderProgressionApi.prototype.getIndicationConfigsFromOrderProgressionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIndicationConfigsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a list of indications with matching names, and a list of options with matching option names
     */
    OrderProgressionApi.prototype.getIndicationConfigsWithRelatedOptionsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.query === null || requestParameters.query === undefined) {
                            throw new runtime.RequiredError('query', 'Required parameter requestParameters.query was null or undefined when calling getIndicationConfigsWithRelatedOptionsFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.query !== undefined) {
                            queryParameters['query'] = requestParameters.query;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs/options/configs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationsWithRelatedOptionsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a list of indications with matching names, and a list of options with matching option names
     */
    OrderProgressionApi.prototype.getIndicationConfigsWithRelatedOptionsFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getIndicationConfigsWithRelatedOptionsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns the most recently edited timestamps and user emails.
     */
    OrderProgressionApi.prototype.getLastEditorsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling getLastEditorsFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{rqid}/audits-last-editors".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return jsonValue.map(models_1.OpsAuditLastEditorsDtoFromJSON); })];
                }
            });
        });
    };
    /**
     * Returns the most recently edited timestamps and user emails.
     */
    OrderProgressionApi.prototype.getLastEditorsFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getLastEditorsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns a medical necessity rule given an id
     */
    OrderProgressionApi.prototype.getMedicalNecessityRuleFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
                            throw new runtime.RequiredError('ruleId', 'Required parameter requestParameters.ruleId was null or undefined when calling getMedicalNecessityRuleFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/medical-necessity-rules/{ruleId}".replace("{".concat("ruleId", "}"), encodeURIComponent(String(requestParameters.ruleId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsMedicalNecessityRuleWithPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns a medical necessity rule given an id
     */
    OrderProgressionApi.prototype.getMedicalNecessityRuleFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getMedicalNecessityRuleFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
     * Returns a list of policies along with the pagination info for the query
     */
    OrderProgressionApi.prototype.getPoliciesFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.filters !== undefined) {
                            queryParameters['filters'] = requestParameters.filters;
                        }
                        if (requestParameters.otherFilters !== undefined) {
                            queryParameters['otherFilters'] = requestParameters.otherFilters;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSearchPoliciesResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * The policy definitions used for meeting medical necessity. pagination, filtering, and sorting optional
     * Returns a list of policies along with the pagination info for the query
     */
    OrderProgressionApi.prototype.getPoliciesFromOrderProgressionController = function (requestParameters, initOverrides) {
        if (requestParameters === void 0) { requestParameters = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPoliciesFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
     * Returns data related to a requisition and optionally, a plan for obtaining medical necessity
     */
    OrderProgressionApi.prototype.getPolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling getPolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieves data for a requistion given the rqid. Optionally returns a plan for obtaining medical necessity. By default, this endpoint only uses insurance policies. To use non-insurance policies, ex. test recommendations, set useInsurancePolicies to false
     * Returns data related to a requisition and optionally, a plan for obtaining medical necessity
     */
    OrderProgressionApi.prototype.getPolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List of available primary indication names used by backoffice/portal
     * Returns a list of primary indications
     */
    OrderProgressionApi.prototype.getPrimaryIndicationNamesFromOrderProgressionControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/primary-indications",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response)];
                }
            });
        });
    };
    /**
     * List of available primary indication names used by backoffice/portal
     * Returns a list of primary indications
     */
    OrderProgressionApi.prototype.getPrimaryIndicationNamesFromOrderProgressionController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getPrimaryIndicationNamesFromOrderProgressionControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns lineage options and relationship type options with configurations
     */
    OrderProgressionApi.prototype.getRelativeConfigsFromOrderProgressionControllerRaw = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/relative-configs",
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsRelativeConfigsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns lineage options and relationship type options with configurations
     */
    OrderProgressionApi.prototype.getRelativeConfigsFromOrderProgressionController = function (initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRelativeConfigsFromOrderProgressionControllerRaw(initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Get Requisition by ReqRepo Requisition Id
     */
    OrderProgressionApi.prototype.getRqFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling getRqFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.plan !== undefined) {
                            queryParameters['plan'] = requestParameters.plan;
                        }
                        if (requestParameters.multipleRuleSatisfaction !== undefined) {
                            queryParameters['multipleRuleSatisfaction'] = requestParameters.multipleRuleSatisfaction;
                        }
                        if (requestParameters.allowUnconfirmedFields !== undefined) {
                            queryParameters['allowUnconfirmedFields'] = requestParameters.allowUnconfirmedFields;
                        }
                        if (requestParameters.userEmail !== undefined) {
                            queryParameters['userEmail'] = requestParameters.userEmail;
                        }
                        if (requestParameters.useInsurancePolicies !== undefined) {
                            queryParameters['useInsurancePolicies'] = requestParameters.useInsurancePolicies;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{rqid}".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsRequisitionResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Get Requisition by ReqRepo Requisition Id
     */
    OrderProgressionApi.prototype.getRqFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRqFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns an LMN generated attachment object model for an rq given a met rule id
     */
    OrderProgressionApi.prototype.getRqLmnAttachmentForMetRuleFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getRqLmnAttachmentForMetRuleFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{id}/mn-rule-attachment".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsAttachmentDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns an LMN generated attachment object model for an rq given a met rule id
     */
    OrderProgressionApi.prototype.getRqLmnAttachmentForMetRuleFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRqLmnAttachmentForMetRuleFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
     * Returns a satisfied policy for the given requisition\'s current state, if one exists
     */
    OrderProgressionApi.prototype.getRqSatisfiedPolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getRqSatisfiedPolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.useInsurancePolicies !== undefined) {
                            queryParameters['useInsurancePolicies'] = requestParameters.useInsurancePolicies;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{id}/satisfied-policy".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Will exhaust all the available policies in rank order returning the first policy where medical necessity is met. If none met response will be an empty object.
     * Returns a satisfied policy for the given requisition\'s current state, if one exists
     */
    OrderProgressionApi.prototype.getRqSatisfiedPolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getRqSatisfiedPolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * List payor audit logs
     */
    OrderProgressionApi.prototype.listPayorAuditsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.payorName === null || requestParameters.payorName === undefined) {
                            throw new runtime.RequiredError('payorName', 'Required parameter requestParameters.payorName was null or undefined when calling listPayorAuditsFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        if (requestParameters.page !== undefined) {
                            queryParameters['page'] = requestParameters.page;
                        }
                        if (requestParameters.size !== undefined) {
                            queryParameters['size'] = requestParameters.size;
                        }
                        if (requestParameters.sort !== undefined) {
                            queryParameters['sort'] = requestParameters.sort;
                        }
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/audit/{payorName}".replace("{".concat("payorName", "}"), encodeURIComponent(String(requestParameters.payorName))),
                            method: 'GET',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPageableAuditLogEntryDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * List payor audit logs
     */
    OrderProgressionApi.prototype.listPayorAuditsFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.listPayorAuditsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * Create a new indication attribute configuration
     */
    OrderProgressionApi.prototype.patchAttributeConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.attributeConfigId === null || requestParameters.attributeConfigId === undefined) {
                            throw new runtime.RequiredError('attributeConfigId', 'Required parameter requestParameters.attributeConfigId was null or undefined when calling patchAttributeConfigFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchAttributeConfigRequestObjectDto === null || requestParameters.opsPatchAttributeConfigRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsPatchAttributeConfigRequestObjectDto', 'Required parameter requestParameters.opsPatchAttributeConfigRequestObjectDto was null or undefined when calling patchAttributeConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/attribute-configs/{attributeConfigId}".replace("{".concat("attributeConfigId", "}"), encodeURIComponent(String(requestParameters.attributeConfigId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchAttributeConfigRequestObjectDtoToJSON)(requestParameters.opsPatchAttributeConfigRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationAttributeConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new indication attribute for medical necessity review
     * Create a new indication attribute configuration
     */
    OrderProgressionApi.prototype.patchAttributeConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchAttributeConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new indication for medical necessity review
     * Create a new indication configuration
     */
    OrderProgressionApi.prototype.patchIndicationConfigFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationConfigId === null || requestParameters.indicationConfigId === undefined) {
                            throw new runtime.RequiredError('indicationConfigId', 'Required parameter requestParameters.indicationConfigId was null or undefined when calling patchIndicationConfigFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchIndicationConfigRequestObjectDto === null || requestParameters.opsPatchIndicationConfigRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsPatchIndicationConfigRequestObjectDto', 'Required parameter requestParameters.opsPatchIndicationConfigRequestObjectDto was null or undefined when calling patchIndicationConfigFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-configs/{indicationConfigId}".replace("{".concat("indicationConfigId", "}"), encodeURIComponent(String(requestParameters.indicationConfigId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchIndicationConfigRequestObjectDtoToJSON)(requestParameters.opsPatchIndicationConfigRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationConfigDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new indication for medical necessity review
     * Create a new indication configuration
     */
    OrderProgressionApi.prototype.patchIndicationConfigFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchIndicationConfigFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch a proband
     */
    OrderProgressionApi.prototype.patchProbandFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.probandId === null || requestParameters.probandId === undefined) {
                            throw new runtime.RequiredError('probandId', 'Required parameter requestParameters.probandId was null or undefined when calling patchProbandFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchProbandRequestObjectDto === null || requestParameters.opsPatchProbandRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsPatchProbandRequestObjectDto', 'Required parameter requestParameters.opsPatchProbandRequestObjectDto was null or undefined when calling patchProbandFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/probands/{probandId}".replace("{".concat("probandId", "}"), encodeURIComponent(String(requestParameters.probandId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchProbandRequestObjectDtoToJSON)(requestParameters.opsPatchProbandRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsProbandDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch a proband
     */
    OrderProgressionApi.prototype.patchProbandFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchProbandFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * answer a planner question, patches requisition object
     */
    OrderProgressionApi.prototype.patchQuestionAnswerFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling patchQuestionAnswerFromOrderProgressionController.');
                        }
                        if (requestParameters.opsQuestionAnswerRequestDto === null || requestParameters.opsQuestionAnswerRequestDto === undefined) {
                            throw new runtime.RequiredError('opsQuestionAnswerRequestDto', 'Required parameter requestParameters.opsQuestionAnswerRequestDto was null or undefined when calling patchQuestionAnswerFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{id}/question-answer".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsQuestionAnswerRequestDtoToJSON)(requestParameters.opsQuestionAnswerRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSuccessPATCHAnswerToQuestionDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * answer a planner question, patches requisition object
     */
    OrderProgressionApi.prototype.patchQuestionAnswerFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchQuestionAnswerFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Patch a relative
     */
    OrderProgressionApi.prototype.patchRelativeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.relativeId === null || requestParameters.relativeId === undefined) {
                            throw new runtime.RequiredError('relativeId', 'Required parameter requestParameters.relativeId was null or undefined when calling patchRelativeFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchRelativeRequestObjectDto === null || requestParameters.opsPatchRelativeRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsPatchRelativeRequestObjectDto', 'Required parameter requestParameters.opsPatchRelativeRequestObjectDto was null or undefined when calling patchRelativeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/relatives/{relativeId}".replace("{".concat("relativeId", "}"), encodeURIComponent(String(requestParameters.relativeId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchRelativeRequestObjectDtoToJSON)(requestParameters.opsPatchRelativeRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsRelativeDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Patch a relative
     */
    OrderProgressionApi.prototype.patchRelativeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRelativeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
     * Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
     */
    OrderProgressionApi.prototype.patchRqCheckForUpdatesFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling patchRqCheckForUpdatesFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{id}/check-for-updates".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSuccessPATCHExternalUpdatesDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the requisition object model in MNR if updates are available, will return an \'updated\' boolean flag in a response object
     * Will call out to our external services (reqrepo bpa, reqrepo v3, pds) and check for updates to the Requisition
     */
    OrderProgressionApi.prototype.patchRqCheckForUpdatesFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRqCheckForUpdatesFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
     */
    OrderProgressionApi.prototype.patchRqFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.id === null || requestParameters.id === undefined) {
                            throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling patchRqFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchRequisitionRequestDto === null || requestParameters.opsPatchRequisitionRequestDto === undefined) {
                            throw new runtime.RequiredError('opsPatchRequisitionRequestDto', 'Required parameter requestParameters.opsPatchRequisitionRequestDto was null or undefined when calling patchRqFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{id}".replace("{".concat("id", "}"), encodeURIComponent(String(requestParameters.id))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchRequisitionRequestDtoToJSON)(requestParameters.opsPatchRequisitionRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsSuccessPATCHAnswerToQuestionDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Returns data related to a requisition and optionally, a plan for obtaining medical necessity.
     */
    OrderProgressionApi.prototype.patchRqFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRqFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
     * Patches a medical necessity rule and relational definitions
     */
    OrderProgressionApi.prototype.patchRuleFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.ruleId === null || requestParameters.ruleId === undefined) {
                            throw new runtime.RequiredError('ruleId', 'Required parameter requestParameters.ruleId was null or undefined when calling patchRuleFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPatchRuleRequestObjectDto === null || requestParameters.opsPatchRuleRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsPatchRuleRequestObjectDto', 'Required parameter requestParameters.opsPatchRuleRequestObjectDto was null or undefined when calling patchRuleFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/medical-necessity-rules/{ruleId}".replace("{".concat("ruleId", "}"), encodeURIComponent(String(requestParameters.ruleId))),
                            method: 'PATCH',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPatchRuleRequestObjectDtoToJSON)(requestParameters.opsPatchRuleRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsMedicalNecessityRuleWithPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates the medical necessity rule with id, rule_id, along with all of the child relationships, only if the policy is in draft mode
     * Patches a medical necessity rule and relational definitions
     */
    OrderProgressionApi.prototype.patchRuleFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patchRuleFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new attribute for an indication
     */
    OrderProgressionApi.prototype.postIndicationAttributeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationId === null || requestParameters.indicationId === undefined) {
                            throw new runtime.RequiredError('indicationId', 'Required parameter requestParameters.indicationId was null or undefined when calling postIndicationAttributeFromOrderProgressionController.');
                        }
                        if (requestParameters.opsCreateIndicationAttributeRequestObjectDto === null || requestParameters.opsCreateIndicationAttributeRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsCreateIndicationAttributeRequestObjectDto', 'Required parameter requestParameters.opsCreateIndicationAttributeRequestObjectDto was null or undefined when calling postIndicationAttributeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indications/{indicationId}/attributes".replace("{".concat("indicationId", "}"), encodeURIComponent(String(requestParameters.indicationId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsCreateIndicationAttributeRequestObjectDtoToJSON)(requestParameters.opsCreateIndicationAttributeRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationAttributeDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new attribute for an indication
     */
    OrderProgressionApi.prototype.postIndicationAttributeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postIndicationAttributeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create an indication for a proband
     */
    OrderProgressionApi.prototype.postProbandIndicationFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.probandId === null || requestParameters.probandId === undefined) {
                            throw new runtime.RequiredError('probandId', 'Required parameter requestParameters.probandId was null or undefined when calling postProbandIndicationFromOrderProgressionController.');
                        }
                        if (requestParameters.opsCreateIndicationRequestObjectDto === null || requestParameters.opsCreateIndicationRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsCreateIndicationRequestObjectDto', 'Required parameter requestParameters.opsCreateIndicationRequestObjectDto was null or undefined when calling postProbandIndicationFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/probands/{probandId}/indications".replace("{".concat("probandId", "}"), encodeURIComponent(String(requestParameters.probandId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsCreateIndicationRequestObjectDtoToJSON)(requestParameters.opsCreateIndicationRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an indication for a proband
     */
    OrderProgressionApi.prototype.postProbandIndicationFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postProbandIndicationFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Creates a new relative for a proband
     */
    OrderProgressionApi.prototype.postRelativeForProbandFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.probandId === null || requestParameters.probandId === undefined) {
                            throw new runtime.RequiredError('probandId', 'Required parameter requestParameters.probandId was null or undefined when calling postRelativeForProbandFromOrderProgressionController.');
                        }
                        if (requestParameters.opsCreateRelativeRequestDto === null || requestParameters.opsCreateRelativeRequestDto === undefined) {
                            throw new runtime.RequiredError('opsCreateRelativeRequestDto', 'Required parameter requestParameters.opsCreateRelativeRequestDto was null or undefined when calling postRelativeForProbandFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/probands/{probandId}/relatives".replace("{".concat("probandId", "}"), encodeURIComponent(String(requestParameters.probandId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsCreateRelativeRequestDtoToJSON)(requestParameters.opsCreateRelativeRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsRelativeConfigsDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Creates a new relative for a proband
     */
    OrderProgressionApi.prototype.postRelativeForProbandFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRelativeForProbandFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Create an indication for a relative
     */
    OrderProgressionApi.prototype.postRelativeIndicationFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.relativeId === null || requestParameters.relativeId === undefined) {
                            throw new runtime.RequiredError('relativeId', 'Required parameter requestParameters.relativeId was null or undefined when calling postRelativeIndicationFromOrderProgressionController.');
                        }
                        if (requestParameters.opsCreateIndicationRequestObjectDto === null || requestParameters.opsCreateIndicationRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsCreateIndicationRequestObjectDto', 'Required parameter requestParameters.opsCreateIndicationRequestObjectDto was null or undefined when calling postRelativeIndicationFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/relatives/{relativeId}/indications".replace("{".concat("relativeId", "}"), encodeURIComponent(String(requestParameters.relativeId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsCreateIndicationRequestObjectDtoToJSON)(requestParameters.opsCreateIndicationRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Create an indication for a relative
     */
    OrderProgressionApi.prototype.postRelativeIndicationFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRelativeIndicationFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
     * Finalizes the derived models for a requisition
     */
    OrderProgressionApi.prototype.postRqConfirmDerivedModelsFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling postRqConfirmDerivedModelsFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/requisitions/{rqid}/confirm-derived-models".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.VoidApiResponse(response)];
                }
            });
        });
    };
    /**
     * This call will go through ALL indications and indication attributes for a proband and their relatives, as well as the relatives themselves, that were derived algorithmically (currently only from CIES, Clinical Information Extraction Service), and mark them as is_finalized=True. is_finalized represents a human confirming the models derived from an algorithm.
     * Finalizes the derived models for a requisition
     */
    OrderProgressionApi.prototype.postRqConfirmDerivedModelsFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.postRqConfirmDerivedModelsFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Check detailed requirements for a payor and set prior auth rules and targeting
     * Check requirements for prior auth
     */
    OrderProgressionApi.prototype.priorAuthPolicyValidateByPayorFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.payorId === null || requestParameters.payorId === undefined) {
                            throw new runtime.RequiredError('payorId', 'Required parameter requestParameters.payorId was null or undefined when calling priorAuthPolicyValidateByPayorFromOrderProgressionController.');
                        }
                        if (requestParameters.opsPriorAuthValidationRequestDto === null || requestParameters.opsPriorAuthValidationRequestDto === undefined) {
                            throw new runtime.RequiredError('opsPriorAuthValidationRequestDto', 'Required parameter requestParameters.opsPriorAuthValidationRequestDto was null or undefined when calling priorAuthPolicyValidateByPayorFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/prior-auth/policies/payor/{payorId}/validate".replace("{".concat("payorId", "}"), encodeURIComponent(String(requestParameters.payorId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsPriorAuthValidationRequestDtoToJSON)(requestParameters.opsPriorAuthValidationRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPriorAuthValidationResponseDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Check detailed requirements for a payor and set prior auth rules and targeting
     * Check requirements for prior auth
     */
    OrderProgressionApi.prototype.priorAuthPolicyValidateByPayorFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.priorAuthPolicyValidateByPayorFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
     * PUBLISH a given policy
     */
    OrderProgressionApi.prototype.publishPolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling publishPolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}/publish".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This marks the policy is_draft=False, is_active=True and turns all other versions of the policy to is_active=False
     * PUBLISH a given policy
     */
    OrderProgressionApi.prototype.publishPolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.publishPolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an indication attribute
     */
    OrderProgressionApi.prototype.putIndicationAttributeFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.attributeId === null || requestParameters.attributeId === undefined) {
                            throw new runtime.RequiredError('attributeId', 'Required parameter requestParameters.attributeId was null or undefined when calling putIndicationAttributeFromOrderProgressionController.');
                        }
                        if (requestParameters.opsUpdateIndicationAttributeRequestObjectDto === null || requestParameters.opsUpdateIndicationAttributeRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsUpdateIndicationAttributeRequestObjectDto', 'Required parameter requestParameters.opsUpdateIndicationAttributeRequestObjectDto was null or undefined when calling putIndicationAttributeFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indication-attributes/{attributeId}".replace("{".concat("attributeId", "}"), encodeURIComponent(String(requestParameters.attributeId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsUpdateIndicationAttributeRequestObjectDtoToJSON)(requestParameters.opsUpdateIndicationAttributeRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationAttributeDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an indication attribute
     */
    OrderProgressionApi.prototype.putIndicationAttributeFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putIndicationAttributeFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Update an indication
     */
    OrderProgressionApi.prototype.putIndicationFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.indicationId === null || requestParameters.indicationId === undefined) {
                            throw new runtime.RequiredError('indicationId', 'Required parameter requestParameters.indicationId was null or undefined when calling putIndicationFromOrderProgressionController.');
                        }
                        if (requestParameters.opsUpdateIndicationRequestObjectDto === null || requestParameters.opsUpdateIndicationRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsUpdateIndicationRequestObjectDto', 'Required parameter requestParameters.opsUpdateIndicationRequestObjectDto was null or undefined when calling putIndicationFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/indications/{indicationId}".replace("{".concat("indicationId", "}"), encodeURIComponent(String(requestParameters.indicationId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsUpdateIndicationRequestObjectDtoToJSON)(requestParameters.opsUpdateIndicationRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsIndicationDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Update an indication
     */
    OrderProgressionApi.prototype.putIndicationFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.putIndicationFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     */
    OrderProgressionApi.prototype.submitBillingReviewFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling submitBillingReviewFromOrderProgressionController.');
                        }
                        if (requestParameters.opsDocumentReviewRequestDto === null || requestParameters.opsDocumentReviewRequestDto === undefined) {
                            throw new runtime.RequiredError('opsDocumentReviewRequestDto', 'Required parameter requestParameters.opsDocumentReviewRequestDto was null or undefined when calling submitBillingReviewFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/billing-review/attachment-review/{rqid}".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsDocumentReviewRequestDtoToJSON)(requestParameters.opsDocumentReviewRequestDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.DocumentationReviewDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     */
    OrderProgressionApi.prototype.submitBillingReviewFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.submitBillingReviewFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
     * Un-archives a given policy
     */
    OrderProgressionApi.prototype.unarchivePolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling unarchivePolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}/unarchive".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'POST',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * This un-archives the policy, ie. changes from is_draft=False, is_active=False to is_draft=True, is_active=False
     * Un-archives a given policy
     */
    OrderProgressionApi.prototype.unarchivePolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unarchivePolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates lastSeen value of RQ in billing-review list
     */
    OrderProgressionApi.prototype.updateLastTimeSeenFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.rqid === null || requestParameters.rqid === undefined) {
                            throw new runtime.RequiredError('rqid', 'Required parameter requestParameters.rqid was null or undefined when calling updateLastTimeSeenFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/billing-review/{rqid}/last-seen".replace("{".concat("rqid", "}"), encodeURIComponent(String(requestParameters.rqid))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.TextApiResponse(response)];
                }
            });
        });
    };
    /**
     * Updates lastSeen value of RQ in billing-review list
     */
    OrderProgressionApi.prototype.updateLastTimeSeenFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updateLastTimeSeenFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Updates a policy and returns the updated policy
     * Updates a policy given the request object data
     */
    OrderProgressionApi.prototype.updatePolicyFromOrderProgressionControllerRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, token, tokenString, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.policyId === null || requestParameters.policyId === undefined) {
                            throw new runtime.RequiredError('policyId', 'Required parameter requestParameters.policyId was null or undefined when calling updatePolicyFromOrderProgressionController.');
                        }
                        if (requestParameters.opsUpdatePolicyRequestObjectDto === null || requestParameters.opsUpdatePolicyRequestObjectDto === undefined) {
                            throw new runtime.RequiredError('opsUpdatePolicyRequestObjectDto', 'Required parameter requestParameters.opsUpdatePolicyRequestObjectDto was null or undefined when calling updatePolicyFromOrderProgressionController.');
                        }
                        queryParameters = {};
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (!(this.configuration && this.configuration.accessToken)) return [3 /*break*/, 2];
                        token = this.configuration.accessToken;
                        return [4 /*yield*/, token("bearer", [])];
                    case 1:
                        tokenString = _a.sent();
                        if (tokenString) {
                            headerParameters["Authorization"] = "Bearer ".concat(tokenString);
                        }
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.request({
                            path: "/order-progression/policies/{policyId}".replace("{".concat("policyId", "}"), encodeURIComponent(String(requestParameters.policyId))),
                            method: 'PUT',
                            headers: headerParameters,
                            query: queryParameters,
                            body: (0, models_1.OpsUpdatePolicyRequestObjectDtoToJSON)(requestParameters.opsUpdatePolicyRequestObjectDto),
                        }, initOverrides)];
                    case 3:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return (0, models_1.OpsPolicyDtoFromJSON)(jsonValue); })];
                }
            });
        });
    };
    /**
     * Updates a policy and returns the updated policy
     * Updates a policy given the request object data
     */
    OrderProgressionApi.prototype.updatePolicyFromOrderProgressionController = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.updatePolicyFromOrderProgressionControllerRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return OrderProgressionApi;
}(runtime.BaseAPI));
exports.OrderProgressionApi = OrderProgressionApi;
